<!--确认收款/付款 -->
<template>
  <div v-loading="loading">
    <el-form
      :rules="rules"
      :model="receiptData"
      label-width="120px"
      ref="submitData"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="单据总金额">
              <el-input v-model="receiptData.SumPayable" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="type==0||type==1?'剩余收款金额':'剩余付款金额'">
              <el-input v-model="receiptData.Unpaid" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="type==0||type==1?'现申请收款金额':'现申请付款金额'">
              <el-input v-model="receiptData.NowPay" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="结算方式" prop="PayType">
              <el-select
                v-model="submitData.PayType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in payWayList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="type==0||type==1?'实收金额':'实付金额'" prop="NowPay">
              <el-input
                type="number"
                step="1"
                v-model="submitData.NowPay"
                :min="0"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-form-item label="备注">
              <el-input
                v-model="submitData.Remark"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-ctn">
      <el-button size="small" class="search-btn" @click="cancel()"
        >取消</el-button
      >
      <el-button
        size="small"
        class="search-btn btn-primary"
        @click="submitForm()"
        >提交确认</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["receiptData","type"],
  components: {},
  data() {
    return {
      loading: false,
      payDataCount: 0,
      waitPay: 0,
      payWayList: [],
      submitData: {
        RecordId: "",
        NowPay: "",
        PayType: "",
        Remark: "",
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "change" }],
        NowPay: [
          { required: true, message: "该项必填", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.submitData.RecordId = this.receiptData.Id;
    this.submitData.NowPay = this.receiptData.NowPay;
    this.submitData.PayType = this.receiptData.PayType;
    this.submitData.Remark = this.receiptData.Remark;

    //this.waitPay = Number(this.receiptData.Unpaid);
    this.getPay();
  },
  methods: {
    cancel() {
      this.$emit("closeReceipt");
    },
    submitForm() {
      if (this.submitData.NowPay <= 0) {
        this.$util.warningMsg("实收金额必须大于0");
        return;
      }
      // if (
      //   parseFloat(this.submitData.NowPay) > parseFloat(this.waitPay)
      // ) {
      //   this.$confirm("收款金额已超过剩余收款金额，是否继续申请收款？", "提示", {
      //     confirmButtonText: "确定继续申请",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //     center: false,
      //   })
      //     .then(() => {
      //       this.$refs["submitData"].validate((valid) => {
      //         if (valid) {
      //           this.$util
      //             .axiosPost({
      //               url:
      //                  "/api/RevenueManagement/ConfirmApplyPaymentOrReceipt",
      //               data: this.submitData,
      //             })
      //             .then((res) => {
      //               this.$util.successMsg(res.errmsg);
      //               this.$emit("closeReceipt",true);
      //             })
      //             .catch(() => {});
      //         } else {
      //           return false;
      //         }
      //       });
      //     })
      //     .catch(() => {});
      // } else
        this.$refs["submitData"].validate((valid) => {
          if (valid) {
            this.loading=true;
            this.$util
              .axiosPost({
                url:
                  "/api/RevenueManagement/ConfirmApplyPaymentOrReceipt",
                data: this.submitData,
                hideLoading: true,
              })
              .then((res) => {
                this.$util.successMsg(res.errmsg);
                this.$emit("closeReceipt",true);
              })
              .catch(() => {this.loading=false});
          } else {
            return false;
          }
        });
    },
    //  结算方式
    getPay() {
      this.$util.getPay().then((data) => {
        this.payWayList = data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
